import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { CustomTabSection } from './constants';

export const CustomTabSectionTranslated: Record<CustomTabSection, MessageDescriptor> = defineMessages({
  [CustomTabSection.Custom]: {
    id: `components.form.date_range_picker.tab.custom.section.custom`,
  },
  [CustomTabSection.Recent]: {
    id: `components.form.date_range_picker.tab.custom.section.recent`,
  },
});

export const Form = defineMessages({
  invalidDate: {
    id: `components.form.date_range_picker.tab.custom.section.custom.invalidDate`,
  },
  from: {
    id: `components.form.date_range_picker.tab.custom.section.custom.from`,
  },
  to: {
    id: `components.form.date_range_picker.tab.custom.section.custom.to`,
  },
});
